// extracted by mini-css-extract-plugin
module.exports = {"text":"_StandardText_text__FYhbC"};